<template>
  <footer class="foot">
    <div class="w1200">
      <div class="left">
        <p><img :src="footLogo.Logo" alt="" /></p>
        <ul>
          <li>地址：南京市江宁区铜山金铜路2号</li>
          <li>电话：400 809 9055</li>
          <li>招生办邮箱：zsb@jku.cn</li>
          <li>Coyright © 金肯职业技术学院 All rights reserved.</li>
          <li>
            <a href="https://beian.miit.gov.cn/" target="_blank"
              >苏ICP备11073940号-3</a
            >
            <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank"
              ><em></em>苏公网安备32011502012155号</a
            >
          </li>
        </ul>
      </div>
      <div class="right">
        <ul class="flexDiv wow fadeInRight" id="footer_ewm">
          <li v-for="(item, index) in codeData" :key="index">
            <p><img :src="item.Cover" alt="" /></p>
            <span>{{ item.Title }}</span>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "foot",
  data() {
    return {
      codeData: []
    };
  },
  created() {
    this.codeData = this.Base.GetNewsInfoByCid(5516, true, 1, "", 3);
    // console.log(this.codeData,'codeData')
    this.footLogo = this.Base.GetDepartmentByDid(260);
  }
};
</script>
<style lang="less" scoped>
.foot {
  height: 3rem;
  background-color: #0376be;
  position: relative;
  .left {
    padding-top: 0.01rem;
    padding-left: 0.3rem;
    p {
      width: 3.33rem;
      height: 0.78rem;
      margin: 0.3rem 0 0.14rem;
      img {
        object-fit: contain;
      }
    }
    ul {
      li {
        font-size: 0.2rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.31rem;
        letter-spacing: 0.01rem;
        color: #ffffff;
        a {
          margin-right: 0.1rem;
        }
        em {
          display: inline-block;
          width: 0.18rem;
          height: 0.18rem;
          background-image: url(../assets/img/wa.png);
          margin-right: 0.05rem;
          background-size: cover;
          vertical-align: -0.02rem;
        }
      }
    }
  }
  .right {
    position: absolute;
    top: 0.38rem;
    right: 0.3rem;
    li {
      margin-left: 0.12rem;
      p {
        width: 1.03rem;
        height: 1.03rem;
      }
      span {
        text-align: center;
        font-size: 0.2rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.3rem;
        letter-spacing: 0.02rem;
        color: #ffffff;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue